/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HomeHealthCertificationVisualReferenceRect
 */
export interface HomeHealthCertificationVisualReferenceRect {
    /**
     * 
     */
    minX: number;
    /**
     * 
     */
    maxX: number;
    /**
     * 
     */
    minY: number;
    /**
     * 
     */
    maxY: number;
}

/**
 * Check if a given object implements the HomeHealthCertificationVisualReferenceRect interface.
 */
export function instanceOfHomeHealthCertificationVisualReferenceRect(value: object): value is HomeHealthCertificationVisualReferenceRect {
    if (!('minX' in value) || value['minX'] === undefined) return false;
    if (!('maxX' in value) || value['maxX'] === undefined) return false;
    if (!('minY' in value) || value['minY'] === undefined) return false;
    if (!('maxY' in value) || value['maxY'] === undefined) return false;
    return true;
}

export function HomeHealthCertificationVisualReferenceRectFromJSON(json: any): HomeHealthCertificationVisualReferenceRect {
    return HomeHealthCertificationVisualReferenceRectFromJSONTyped(json, false);
}

export function HomeHealthCertificationVisualReferenceRectFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationVisualReferenceRect {
    if (json == null) {
        return json;
    }
    return {
        
        'minX': json['minX'],
        'maxX': json['maxX'],
        'minY': json['minY'],
        'maxY': json['maxY'],
    };
}

export function HomeHealthCertificationVisualReferenceRectToJSON(json: any): HomeHealthCertificationVisualReferenceRect {
    return HomeHealthCertificationVisualReferenceRectToJSONTyped(json, false);
}

export function HomeHealthCertificationVisualReferenceRectToJSONTyped(value?: HomeHealthCertificationVisualReferenceRect | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'minX': value['minX'],
        'maxX': value['maxX'],
        'minY': value['minY'],
        'maxY': value['maxY'],
    };
}

